import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { HomeComponent } from './home/home.component';
import { SearchComponent } from './search/search.component';
import { ResultComponent } from './result/result.component';
import { WordComponent } from './word/word.component';
import { IonicStorageModule } from '@ionic/storage-angular';
import { initServices } from './services/service-initializer.service';
import { StorageService } from './services/storage.service';
import { HistorySearchService } from './services/history-search.service';
import { FavoriteSearchService } from './services/favorite-search.service';
import { ParagraphSearchComponent } from './paragraph-search/paragraph-search.component';
import { FormsModule } from '@angular/forms';
import { ClickablePipe } from './pipes/clickable.pipe';
import {HelpComponent} from "./help/help.component";

@NgModule({
  declarations: [AppComponent, HomeComponent, SearchComponent, ResultComponent, WordComponent, ParagraphSearchComponent, HelpComponent, ClickablePipe],
  entryComponents: [],
  imports: [BrowserModule, IonicModule.forRoot(), AppRoutingModule, HttpClientModule, IonicStorageModule.forRoot(), FormsModule],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {
      provide: APP_INITIALIZER,
      useFactory: initServices,
      deps: [StorageService, HistorySearchService, FavoriteSearchService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
